var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.to,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function({}){return [_c('li',{class:{
      'router-link-active': _vm.isActive,
      'router-link-exact-active': _vm.isExactActive,
      'disabled': _vm.disabled
    },on:{"click":_vm.navigate}},[_vm._t("default")],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }